import '@babel/polyfill'
import querystring from "querystring";
import React from "react";
import ReactDOM from "react-dom";
import LayerSwitch from "./ui/layer_switch";
import FileBar from "./ui/file_bar";
import ModeButtons from "./ui/mode_buttons";
import User from "./ui/user";
import Map from "./ui/map";
import GithubModal from "./ui/github_modal";
import GistModal from "./ui/gist_modal";
import LayerModal from "./ui/layer_modal";
import Panel from "./panel/index";
import ApolloClient from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloProvider } from "react-apollo";
import magicFile from "./lib/magic_file";
import mergeGeojson from "./lib/merge_geojson";
import { layers } from "./layers";
import { getStxFile } from "./aws/aws_integration";

const client = new ApolloClient({
  link: createHttpLink({ uri: "/github/graphql", credentials: 'include' }),
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__)
});

const initialGeojson = { type: "FeatureCollection", features: [] };

class App extends React.Component {
  state = {
    mode: "metaTable",
    layer: "osm",
    layers: layers,
    githubModal: false,
    gistModal: false,
    layerModal: false,
    geojson: initialGeojson,
    changeFrom: undefined,
    dropzoneActive: false,
    showPanel: true,
    loading: true,
    metadata: {},
    openPopup: false,
    currentPopupOpen: false,
  };

  _parse_query_string = () => {
    const query = window.location.search.substring(1);
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      var key = decodeURIComponent(pair[0]);
      var value = decodeURIComponent(pair[1]);
      // If first entry with this name
      if (typeof query_string[key] === "undefined") {
        query_string[key] = decodeURIComponent(value);
        // If second entry with this name
      } else if (typeof query_string[key] === "string") {
        var arr = [query_string[key], decodeURIComponent(value)];
        query_string[key] = arr;
        // If third or later entry with this name
      } else {
        query_string[key].push(decodeURIComponent(value));
      }
    }
    return query_string;
  }

  togglePanel = () => {
    this.setState(({ showPanel }) => ({
      showPanel: !showPanel
    }));
  };
  setMetadata = metadata => {
    this.setState({ metadata });
  }
  setMode = mode => {
    this.setState({ mode });
  };
  toggleGithubModal = () => {
    this.setState(({ githubModal }) => ({
      githubModal: !githubModal
    }));
  };
  toggleGistModal = () => {
    this.setState(({ gistModal }) => ({
      gistModal: !gistModal
    }));
  };
  toggleLayerModal = () => {
    this.setState(({ layerModal }) => ({
      layerModal: !layerModal
    }));
  };
  addLayer = event => {
    event.preventDefault();

    const data = new FormData(event.target);

    const id = data.get("id");
    const title = data.get("title");
    const url = data.get("url");
    const attribution = data.get("attribution");

    const newLayer = {
      id,
      title,
      layer: L.tileLayer(url, {
        attribution
      })
    };
    const newLayers = this.state.layers.concat(newLayer);
    this.setState({
      layer: id,
      layers: newLayers,
      layerModal: false
    });
  };
  setLayer = layer => {
    this.setState({ layer });
  };
  setGeojson = (geojson, changeFrom) => {
    this.setState({ geojson, changeFrom });
  };
  importFiles = async files => {
    const { geojson } = this.state;
    const { setGeojson } = this;
    const geojsons = await Promise.all(files.map(file => {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.addEventListener("load", () => {
          resolve(magicFile(reader.result))
        }
        );
      });
    }));
    setGeojson(mergeGeojson([geojson, ...geojsons]));
  };

  onStart = () => {
    const { geojson } = this.state;
    const { setGeojson, setMetadata, _parse_query_string } = this;


    window.onerror = (e) => {
      alert(`\nOh no!\nAn error occurred: ${e}]\n\nPlease take a screenshot of this message and send it to apps+soundtrails@creatio.com.au\n\nFor now, refresh the page and retry`);
    }


    getStxFile().then((geoJsonFromFile) => {
      console.log(this.state.metadata);
      let metadata = this.state.metadata === undefined ? {} : this.state.metadata;
      console.log(metadata);
      try {
        const newGeojson = [magicFile(geoJsonFromFile)];
        //setGeojson();

        // probably needs some more testing but it should work

        if (Object.keys(newGeojson[0].features[0].properties).length >= Object.keys(metadata).length) {
          metadata = newGeojson[0].features[0].properties;
        }

        newGeojson[0].features.shift();
        this.setState({
          metadata: metadata,
          geojson: mergeGeojson([geojson, ...newGeojson])
        });

        // Meta table not automatically refreshing with latest data in some circumstances
        // Programmatically swap panels to force a refresh and show correct data
        this.setMode("HotspotSelector");
        this.setMode("metaTable");
      } catch (e) {
        console.error(e)
      }
    });


    const url = _parse_query_string();
    const metadata = this.state.metadata;

    if (metadata.copyright === undefined) {
      if (url.copyright !== undefined) {
        let meta = metadata;
        meta["copyright"] = url.copyright;
        setMetadata(meta)
      }
    }
    if (metadata.imageBaseUrl === undefined) {
      if (url.imageBaseUrl !== undefined) {
        let meta = metadata;
        meta["imageBaseUrl"] = url.imageBaseUrl;
        setMetadata(meta)
      }
    }
    if (metadata.audioBaseUrl === undefined) {
      if (url.audioBaseUrl !== undefined) {
        let meta = metadata;
        meta["audioBaseUrl"] = url.audioBaseUrl;
        setMetadata(meta)
      }
    }

    this.setState(() => ({
      loading: false
    }));

  }

  render() {
    const {
      geojson,
      geojsonObject,
      changeFrom,
      layer,
      layers,
      map,
      mode,
      githubModal,
      gistModal,
      layerModal,
      loading,
      dropzoneActive,
      showPanel,
      metadata,
      hasError,
      openPopup,
      currentPopupOpen
    } = this.state;
    const { setGeojson, setLayer, setMode, togglePanel, onStart, setMetadata } = this;

    if (loading) {
      onStart()
      return (<div>Loading...</div>)
    }
    return (
      <ApolloProvider client={client}>
        <div className="f6 sans-serif fw6">
          <div className="vh-100 flex">
            <div
              className={`w-${showPanel ? "60" : "100"} flex flex-column z-0`}
            >
              <FileBar
                style={{ height: "36px" }}
                metadata={metadata}
                geojson={geojson}
                geojsonObject={geojsonObject}
                setGeojson={setGeojson}
                toggleGithubModal={this.toggleGithubModal}
                toggleGistModal={this.toggleGistModal}
                toggleConfigModal={this.toggleConfigModal}
              />
              <Map
                openPopup={(id) => {
                  if (id !== false) {
                    this.setState(() => ({ openPopup: id, currentPopupOpen: id }))
                  } else {
                    this.setState(() => ({ openPopup: id }))
                  }
                }}
                openPopupId={openPopup}
                currentPopupOpen={currentPopupOpen}
                metadata={metadata}
                setMetadata={setMetadata}
                layer={layer}
                layers={layers}
                geojson={geojson}
                setGeojson={setGeojson}
                changeFrom={changeFrom}
                showPanel={showPanel}
              />
              <div className="flex justify-between bt">
                {/* <LayerSwitch
                      layers={layers}
                      layer={layer}
                      setLayer={setLayer}
                    />
                    <div
                      onClick={this.toggleLayerModal}
                      className="f6 fw7 dib pa2 no-underline bg-white hover-bg-light-blue black pointer"
                    >
                      Add layer
                    </div> */}
                <span onClick={this.togglePanel}>
                  <div style={{ cursor: "pointer" }}><u>
                    {showPanel ? "CLOSE PANEL" : "OPEN PANEL"}
                  </u></div>
                </span>
              </div>
            </div>
            {showPanel && (
              <div className="w-35 bl flex flex-column">
                <div
                  className="bg-white flex justify-between bb"
                  style={{
                    flexShrink: 0
                  }}
                >
                  <ModeButtons mode={mode} setMode={setMode} />
                  {/* <User /> don't need this. */}
                </div>
                <Panel
                  openPopup={(id) => {
                    if (id !== false) {
                      this.setState(() => ({ openPopup: id, currentPopupOpen: id }))
                    } else {
                      this.setState(() => ({ openPopup: id }))
                    }
                  }}
                  openPopupId={openPopup}
                  currentPopupOpen={currentPopupOpen}
                  mode={mode}
                  geojson={geojson}
                  setGeojson={setGeojson}
                  changeFrom={changeFrom}
                  setMetadata={setMetadata}
                  metadata={metadata}
                />
              </div>
            )}
            {githubModal && (
              <GithubModal toggleGithubModal={this.toggleGithubModal} setGeojson={setGeojson} />
            )}
            {gistModal && <GistModal />}
            {layerModal && (
              <LayerModal
                onCancel={this.toggleLayerModal}
                onSubmit={this.addLayer}
              />
            )}
          </div>
        </div>
        {dropzoneActive && (
          <div
            className="absolute absolute--fill bg-black-20 flex items-center justify-center"
            style={{
              zIndex: 999
            }}
          >
            <div className="sans-serif bg-white pa2 ba">
              Drop files to import
            </div>
          </div>
        )}
      </ApolloProvider>
    );
  }

}
// https://stxeditor.web.app/?
// stx=https://ccpublicbucket.s3-ap-southeast-2.amazonaws.com/published_soundtrails/MalenyTest.stx
// &awsId=AKIAUNHGBCC3SHNJS3N3
// &awsKey=D5cG2bAP1ukCIvf3J1m1+7j8cH6syBK4/XvA7XAk
// &audioBaseUrl=https://soundtrails2020.s3-ap-southeast-2.amazonaws.com/datafiles-st-v1/sounds/
// &imageBaseUrl=https://soundtrails2020.s3-ap-southeast-2.amazonaws.com/datafiles-st-v1/images/
// &copyright=This%20file%20and%20all%20associated%20audio%20and%20image%20files%20are%20%C2%A9%20The%20Story%20Project%202020
// #18/-26.75962/152.85176
ReactDOM.render(<App />, document.getElementById("geojsonnet"));
